import {BlockBuilder} from '../../classes/blockBuilder';
import {BlockType} from '../../classes/blockType';

export const clubLogoGenerator = new BlockType({
  name: 'clubLogoGenerator',
  title: 'Club Logo Generator',
  compatibility: ['page'],
  component: () =>
    import(
      './ClubLogoGeneratorBlock.vue'
    ),
  builder: () => BlockBuilder.create('clubLogoGenerator')
});
